import PanelSmall from './PanelSmall.jsx';

export default PanelSmall;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/FilterGroupCollection/Panels/PanelSmall/index.js